import React from 'react';
import './PhoneMockup.css';

/**
 * Phone Mockup component to display app screenshots
 * Shows an iPhone-style frame around the screenshot
 * @param {string} imageSrc - Source path for the screenshot
 * @param {string} imageAlt - Alt text for accessibility
 */
const PhoneMockup = ({ imageSrc, imageAlt }) => {
  return (
    <div className="phone-mockup" role="img" aria-label={imageAlt}>
      <div className="phone-mockup-frame">
        {/* Screen content */}
        <div className="phone-mockup-screen">
          {imageSrc ? (
            <img
              src={imageSrc}
              alt=""
              className="phone-mockup-image"
              loading="lazy"
            />
          ) : (
            <div className="phone-mockup-placeholder" aria-hidden="true" />
          )}
        </div>
      </div>
    </div>
  );
};

export default PhoneMockup;
